import { defineAsyncComponent } from 'vue';

export default {
	description: "Обработанные накладные",
	access: {
		read: true,
		create: true,
		update: true,
		delete: true
	},
	onAfterDelete: async (row: any) => {
		return true;
	},
	fields: {
		items: {
			description: "Наименование МПС",
			depends: "id",
			type: {
				table: "processed_invoice_items"
			}
		}
	},
	forms: {
		list: {
			component: defineAsyncComponent(() => import('./forms/List.vue')),
			config: {
				fields: {
					invoice_number: {
						config: {
							width: '150px',
							sticky: true,
							sorting: '"processed_invoices"."invoice_number"'
						}
					},
					invoice_date: {
						config: {
							width: '120px',
							sorting: '"processed_invoices"."invoice_date"'
						}
					},
					consignee: {
						config: {
							width: '200px',
							sorting: '"consignee"."name"'
						}
					},
					consignor: {
						config: {
							width: '200px',
							sorting: '"consignor"."name"'
						}
					},
					total_cost: {
						description: "Сумма",
						config: {
							width: '150px',
							sorting: '"processed_invoices"."total_cost"'
						}
					},
					total_vat: {
						description: "Сумма НДС",
						config: {
							width: '120px',
							sorting: '"processed_invoices"."total_vat"'
						}
					},
					total_cost_with_vat: {
						description: "Сумма с НДС",
						config: {
							width: '150px',
							sorting: '"processed_invoices"."total_cost_with_vat"'
						}
					},
					processed_by: {
						config: {
							width: '150px',
							sorting: '"processed_by"."name"'
						}
					},
					processed_at: {
						config: {
							width: '150px',
							sorting: '"processed_invoices"."processed_at"'
						}
					},
					processed_to_stock: {
						config: {
							width: '100px',
							sorting: '"processed_invoices"."processed_to_stock"'
						}
				},
				processed_to_stock_date: {
					config: {
						visible: false,
						hide: true
					}
					}
				}
			},
		},
		edit: {
			panel: {
				width: '80%'
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}
